import $store from '~/services/StoreService';
import Constants from '~/config/Constants';
import Subscription from '~/config/Subscription';

import { OpenQFWUpdateSubscriptionPage } from '~/utils/Redirection';

export default function corporate(to, from, next) {
  const store = $store();
  const user = store.getters['root/userService'];

  function isCorporateAdminOrFreeTrialAccount() {
    return user.userStore.organizationRole === Constants.OrganizationRole.ADMIN;
  }

  if (user.isCorporate) {
    if (
      to.path === '/forwork/dashboard'
      && isCorporateAdminOrFreeTrialAccount()
    ) {
      if (Number(user.subscription?.quantity) < 2 && !user.hasUsageBasedPaywalling) {
        OpenQFWUpdateSubscriptionPage(Subscription.UPDATE_SUBSCRIPTION_TYPE.INVITE_MEMBER, { source: 'middleware' });
        return;
      }
      return next();
    }
  }

  window.location.href = '/admin';
}
